import $ from 'jquery';
import {Swiper, Navigation, Autoplay} from 'swiper/swiper.esm.js';
Swiper.use([Navigation, Autoplay]);

const swiper = new Swiper('.posts-swiper', {
    slidesPerView: 2,
    loop: false,
    autoplay: {
        delay: 2000
    },
    breakpoints: {
        1100: {
            slidesPerView: 3,
        }
    }
});